// 车辆状态
export const carStatus = {
  5: '待入库',
  10: '待处理',
  20: '待租',
  40: '已租',
  15: '售后',
}
// 车务状态
export const carWorkStatus = {
  1: '年审临期',
  2: '交强险临期',
  3: '商业险临期',
  4: '车证临期',
  5: '有违章',
  6: '有事故',
  7: '维修中',
  8: '保养中',
}
// 车辆状态对应的数量字段
export const carSateNumParam = {
  0: 'allCarNum', // 全部
  5: 'noInStockNum', // 待入库
  10: 'toDealNum', // 待处理
  20: 'toLeaseNum', // 待租
  40: 'leasedNum', // 已租
  15: 'unusualNum', // 售后
}
// 车务状态对应的数量字段
export const carWorkSateNumParam = {
  0: 'allCarNum',
  1: 'yearInspectOverDueCarNum',
  2: 'compulsoryInsuranceOverDueCarNum',
  3: 'commercialInsuranceOverDueCarNum',
  4: 'transportLicenseOverDueCarNum',
  5: 'violationNum',
  6: 'accidentNum',
  7: 'maintenanceFixNum',
  8: 'maintenanceMainNum',
}
// 采购状态
export const vehiclePurchaseStatus = {
  0: '未采购',
  3: '已采购',
}
// 车辆基本信息状态
export const carBaseInfoStatus = {
  1: '待补齐',
  2: '待提交',
  3: '核中',
  4: '信息完整',
}
// 运营状态
export const carOperateStateDict = {
  1: '正常',
  2: '保养中',
  3: '维修中',
  4: '事故中',
}
// 底盘和外观状态
export const outerBottomState = {
  1: '正常',
  2: '异常',
  3: '裂痕',
  4: '脱落',
  5: '划伤',
  6: '凹陷',
  7: '丢失',
}
export const obj2arr = (obj) => {
  const arr = []
  Object.keys(obj).forEach((params) => {
    arr.push({
      label: obj[params],
      value: Number(params),
    })
  })
  return arr
}

export const jumpMap = {

  // 1-车型
  // 2-vin
  // 3-车牌号
  // 4-发动机号
  // 5-行驶证照片主
  // 6-行驶证照片副
  // 7-行驶证注册日期
  // 8-行驶证
  // 9-登记证照片
  // 10-证照
  // 11-网约车证
  // 15-交强险
  // 16-商业险
  // 17-违章
  // 18-事故
  // 19-维保
  // 20-表显里程
  // 21-维修
  // 22-保养

  // 证件编辑合并页
  // /vehicle/vehicleManage/allEdit

  // 维修-维保列表页面
  // /vehicle/maintenance/list?plateNo=晋1234567&type=1 车牌号自动同步，维保类型是维修

  // 保养-维保列表页面
  // /vehicle/maintenance/list?plateNo=晋1234567&type=2 车牌号自动同步，维保类型是保养

  // 维保养-维保列表页面
  // /vehicle/maintenance/list 车牌号自动同步

  // 事故-事故列表
  // /vehicle/accident/list 车牌号自动同步

  // 违章-违章记录
  // /vehicle/violation/record 车牌号自动同步，违章状态是待处理

  // 交强险-保单管理
  // /vehicle/insurance/insurancePolicy 车牌号自动同步，保险类型是交强险

  // 商业险-保单管理
  // /vehicle/insurance/insurancePolicy 车牌号自动同步，保险类型是商业险

  1: { // ?id=1033180
    url: '/vehicle/vehicleManage/allEdit', // 新版
    queryKey: ['id'],
  },
  2: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  3: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  4: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  5: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  6: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  7: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  8: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  9: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  10: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  11: {
    url: '/vehicle/vehicleManage/allEdit',
    queryKey: ['id'],
  },
  15: { // ?车牌号:plateNo + 交强险:type=1
    url: '/vehicle/insurance/insurancePolicy',
    queryKey: ['plateNo', 'type=1'],
  },
  16: { // ?车牌号:plateNo + 商业险:type=2
    url: '/vehicle/insurance/insurancePolicy',
    queryKey: ['plateNo', 'type=2'],
  },
  17: { // ?车牌号:plateNo + 车辆：id + 违章状态待处理:handleState=0
    url: '/vehicle/violation/record',
    queryKey: ['plateNo', 'id', 'handleState=0'],
  },
  18: { // ?车牌号:plateNo + 车辆:id
    url: '/vehicle/accident/list',
    queryKey: ['plateNo', 'id'],
  },
  19: { // ?车牌号:plateNo
    url: '/vehicle/maintenance/list',
    queryKey: ['plateNo', 'id'],
  },
  20: {
    url: '/vehicle/vehicleManage/allEdit', // 新版
    queryKey: ['id'],
  },
  21: { // ?车牌号:plateNo 维保类型:type
    url: '/vehicle/maintenance/list',
    queryKey: ['plateNo', 'id', 'type=1'],
  },
  22: { // ?车牌号:plateNo 维保类型:type
    url: '/vehicle/maintenance/list',
    queryKey: ['plateNo', 'id', 'type=2'],
  },
}
